import axios from './axios';
import utils from '../libs/utils';

export default {
  axios,
  getToken(filename) {
    // console.log(filename);
    const name = encodeURI(filename);
    return axios.get(`v1/erp-sys-web/upload/credentials?fileName=${name}`);
  },
  upload(file, sign) {
    const formData = new FormData();
    formData.append('key', `${sign.dir}${sign.objectName}`);
    formData.append('name', sign.objectName);
    formData.append('policy', sign.policy);
    formData.append('OSSAccessKeyId', sign.accessid);
    formData.append('success_action_status', '200');
    formData.append('dir', sign.dir);
    formData.append('expire', sign.expire * 1000);
    formData.append('signature', sign.signature);
    formData.append('file', file);
    // console.log(file);

    return axios({
      url: sign.host, // `${signatureObj.host}`,
      // url: '/upload', // `${signatureObj.host}`,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      // withCredentials: false,
    });
  },
  getFile(params) {
    return axios.get(`v1/erp-sys-web/upload/access?${utils.exchangeParams(params)}`);
  },
};
